import { Link } from "react-router-dom";
import { MapPin, Phone, Mail, ArrowUpRight, Instagram } from "lucide-react";
import { LOGO } from "@/lib/media";

export default function Footer() {
  return (
    <footer data-testid="footer" className="bg-[#1A3322] text-[#F4F2EE] relative overflow-hidden">
      <div className="mx-auto max-w-[1400px] px-4 sm:px-8 pt-20 pb-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-8">
          <div className="lg:col-span-5">
            <div className="flex items-center gap-3">
              <img src={LOGO} alt="B FRUIT SRL" className="h-14 w-14 object-contain bg-[#F4F2EE] rounded-full p-1.5" />
              <span className="font-serif-display text-3xl">B FRUIT <span className="italic font-light text-[#E8801F]">srl</span></span>
            </div>
            <p className="mt-6 max-w-md text-[#F4F2EE]/70 leading-relaxed">
              Distribuzione di frutta e verdura fresca per ristoranti, alberghi, hotel e
              supermercati. Selezione quotidiana, filiera corta e consegne puntuali.
            </p>
            <p className="mt-5 text-sm text-[#F4F2EE]/55">R.E.A. VR-476585 · P.IVA 05178040233</p>
            <p className="mt-1 text-sm text-[#F4F2EE]/55">PEC: B.FRUIT.SRL@PEC.IT</p>
          </div>

          <div className="lg:col-span-3">
            <p className="text-xs uppercase tracking-[0.22em] text-[#E8801F] mb-5">Naviga</p>
            <ul className="space-y-3">
              {[
                { to: "/", l: "Home" },
                { to: "/chi-siamo", l: "Chi Siamo" },
                { to: "/servizi", l: "Servizi" },
                { to: "/contatti", l: "Contatti" },
              ].map((i) => (
                <li key={i.to}>
                  <Link to={i.to} className="link-underline text-[#F4F2EE]/85 hover:text-[#F4F2EE] text-lg">
                    {i.l}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          <div className="lg:col-span-4">
            <p className="text-xs uppercase tracking-[0.22em] text-[#E8801F] mb-5">Contatti</p>
            <ul className="space-y-4 text-[#F4F2EE]/85">
              <li className="flex items-start gap-3"><MapPin className="h-5 w-5 mt-0.5 shrink-0 text-[#8A9A5B]" /><span>Sede legale: Via Anfiteatro 10, 37121 Verona (VR)<br/><span className="text-[#F4F2EE]/60">Sede operativa: Via Alva Thomas Edison 10/A</span></span></li>
              <li className="flex items-center gap-3"><Phone className="h-5 w-5 text-[#8A9A5B]" /><a href="tel:+393936707253" className="link-underline">393 6707253</a></li>
              <li className="flex items-center gap-3"><Mail className="h-5 w-5 text-[#8A9A5B]" /><a href="mailto:BFRUITSRL.VR@gmail.com" className="link-underline break-all">BFRUITSRL.VR@gmail.com</a></li>
            </ul>
            <div className="mt-7 flex flex-wrap items-center gap-4">
              <Link to="/contatti" className="group inline-flex items-center gap-2 rounded-full border border-[#F4F2EE]/30 px-5 py-2.5 text-sm hover:bg-[#F4F2EE] hover:text-[#1A3322] transition-colors duration-300">
                Lavora con noi
                <ArrowUpRight className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </Link>
              <a
                href="https://www.instagram.com/bfruit_vr"
                target="_blank"
                rel="noopener noreferrer"
                data-testid="instagram-link"
                aria-label="Instagram B FRUIT SRL"
                className="group inline-flex items-center gap-2 rounded-full border border-[#F4F2EE]/30 px-5 py-2.5 text-sm hover:bg-[#E8801F] hover:border-[#E8801F] hover:text-[#1A3322] transition-colors duration-300"
              >
                <Instagram className="h-4 w-4" />
                @bfruit_vr
              </a>
            </div>
          </div>
        </div>

        <div className="mt-16 pt-6 border-t border-[#F4F2EE]/15 flex flex-col sm:flex-row items-center justify-between gap-3 text-sm text-[#F4F2EE]/55">
          <p>© {new Date().getFullYear()} B FRUIT SRL — Verona, Italia</p>
          <p className="font-serif-display italic text-base">Freschezza, ogni giorno.</p>
        </div>
      </div>
    </footer>
  );
}
